<template>
  <Popper
      v-bind="$attrs"
      trigger="manual"
      v-model:show="isOpen"
      :placement="placement"
  >
    <span
        ref="triggerEl"
        @mouseenter="onEnter"
        @mouseleave="onLeave"
    >
      <slot />
    </span>

    <template #content="props">
      <slot name="content" v-bind="props" />
    </template>
  </Popper>
</template>

<script>
import { ref, defineComponent, onMounted } from "vue";
import Popper from "vue3-popper";

export default defineComponent({
  name: "TooltipWrap",
  components: {Popper},

  props: {
    side: {
      type: String,
      default: "bottom"
    },
    enabled: {
      type: Boolean,
      default: true        // 👈 ключевой флаг
    }
  },

  setup(props) {
    const triggerEl = ref(null);
    const placement = ref("bottom");
    const isOpen = ref(false); // ручное управление

    const onEnter = () => {
      if (!props.enabled) return;  // 👈 запрещаем hover
      isOpen.value = true;
    };

    const onLeave = () => {
      if (!props.enabled) return;
      isOpen.value = false;
    };

    // твоя логика вычисления left/center/right
    onMounted(() => {
      const el = triggerEl.value;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const screenW = window.innerWidth;
      const leftThreshold = screenW / 3;
      const rightThreshold = (screenW * 2) / 3;

      let pos = props.side;

      if (centerX < leftThreshold) pos = `${props.side}-start`;
      else if (centerX > rightThreshold) pos = `${props.side}-end`;

      placement.value = pos;
    });

    return {
      triggerEl,
      placement,
      isOpen,
      onEnter,
      onLeave
    };
  }
});
</script>
